import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { observer, inject } from 'mobx-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faEllipsisH, faSpinner, faPencilAlt, faCheck , faSync} from "@fortawesome/free-solid-svg-icons";

import Utils from "../utils/utils";
import { readApiErrorCode } from "../utils/api-error";
import Modal from '../components/modal';
import Checkbox from "../components/checkbox";
import { fetch } from '../utils/api-wrapper';
import ListHeader from "../components/list-header";
import ListItemDisplay from "../components/list-item-display";
import AsyncSelect from 'react-select/async';

const ExpensesAccount = ({ data }) => {
    const history = useNavigate();
    const source = axios.CancelToken.source();
    const [expensesAccounts, setExpensesAccounts] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [sorting, setSorting] = useState([]);
    const [filters, setFilters] = useState([]);
    const [globalfilter, setGlobalfilter] = useState([]);
    const [xpensesDeleteSelection, setXpensesDeleteSelection] = useState([]);
    const [xpensesDeleteConfirm, setXpensesDeleteConfirm] = useState(false);
    const [savingError, setSavingError] = useState(null);
    const [openCreateAccountModal, setOpenCreateAccountModal] = useState(false);
    const [newAccountDescription, setNewAccountDescription] = useState("");
    const [selectedAssociate, setSelectedAssociate] = useState({value: data.id_user, label: `${data.firstName} ${data.lastName}`});
    const [associates, setAssociates] = useState(null);

    const toggleAllXpensesSelected = () => {
        xpensesDeleteSelection.length === expensesAccounts.length ? setXpensesDeleteSelection([]) : setXpensesDeleteSelection([...expensesAccounts.flatMap(x => x._id.$oid)]);
    }
    const isXpenseSelected = (xpens) => {
        return xpensesDeleteSelection.find(x => x == xpens._id.$oid) != undefined;
    }

    const loadUsersAndAssociates = (search_query = "", callback = () => {
    }) => {
        const val = search_query.trim().replace(/\//g, '');
        const flts = [{ id: "search", value: val }];
        const searchData = `?filters=${encodeURIComponent(JSON.stringify(flts ?? []))}&sorting=${encodeURIComponent(JSON.stringify(sorting ?? []))}`;
        fetch(`/users/associates/${searchData}`, "GET", {}, (response) => {
            const receivedUsers = response?.data?.users.map(u => ({
                ...u,
                label: u?.first_name + " " + u?.last_name,
                value: u._id.$oid
            }));

            if(!associates && receivedUsers && receivedUsers.length > 0)
                setAssociates(receivedUsers);

            callback(receivedUsers);

        })
    }

    const allColums = [
        {"name": "id", "evaluate": inv => inv.description ? inv.description : "", "displayName": "description"},
        { "name": "created_at", "evaluate": inv => Intl.DateTimeFormat(`${data.t.lang}-US`,{year: 'numeric',  month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,  }).format(new Date(inv.created_at.$date)), "displayName": "created_at" },
        { "name": "updated_at", "evaluate": inv => Intl.DateTimeFormat(`${data.t.lang}-US`,{year: 'numeric',  month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,  }).format(new Date(inv.updated_at.$date)), "displayName": "updated_at" },
        { "name": "submitted_at", "evaluate": inv => inv.submitted_at ? Intl.DateTimeFormat(`${data.t.lang}-US`,{year: 'numeric',  month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,  }).format(new Date(inv.submitted_at.$date)) : "", "displayName": "submitted_at" },
        { "name": "currency", "evaluate": inv => inv.currency ? inv.currency : "", "displayName": "currency" },
        { "name": "status", "evaluate": inv => data.t.read(`expense_account_status.${inv.status.toLowerCase()}`), "displayName": "status" },
        { "name": "total", "evaluate": inv => inv.Total ? `$${inv.Total.toFixed(2)}` : "", "displayName": "total" },
        { "name": "totalWithTax", "evaluate": inv => inv.BigTotalPayed ? `$${inv.BigTotalPayed.toFixed(2)}` : "", "displayName": "total_with_tax" },
    ];

    const isAllXpensesSelected = () => {
        if (!expensesAccounts || !expensesAccounts.length)
            return false;
        return xpensesDeleteSelection.length > 1 && xpensesDeleteSelection.length === expensesAccounts.length;
    }

    const deleteXpenses = () => {
        setSaving(true);
        fetch(`/expenses_account/`, "DELETE", { "account_ids": xpensesDeleteSelection },
            response => {
                fetchExpensesAccounts();
                setXpensesDeleteSelection([]);
                setXpensesDeleteConfirm(false);
                setSaving(false);
            }
            , () => { setSaving(false); setXpensesDeleteConfirm(false); }, false, source.token);
    }

    const onExpenseAccountSelectedChange = (expenseAccount) =>
        isXpenseSelected(expenseAccount) ? setXpensesDeleteSelection(xpensesDeleteSelection.filter(x => x !== expenseAccount._id.$oid)) : setXpensesDeleteSelection([...xpensesDeleteSelection, expenseAccount._id.$oid]);

    const fetchExpensesAccounts = (selectedAssociate) => {
        let start = page * pageSize;

        let flts = [];

        if (globalfilter.length !== 0)            
            start = 0;
        

        if (filters.length !== 0){
            start = 0;
            flts.push(...filters);
        }


        if (selectedAssociate?.value && selectedAssociate.value !== data.id_user)
            flts.push({ id: "user.id_user", value: selectedAssociate.value });


        const searchData = `?start=${encodeURIComponent(start)}&page_size=${encodeURIComponent(pageSize)}&globalfilter=${encodeURIComponent(globalfilter ?? '')}&filters=${encodeURIComponent(JSON.stringify(flts ?? []))}&sorting=${encodeURIComponent(JSON.stringify(sorting ?? []))}`;

        fetch(`/expenses_accounts/${searchData}`, "GET", {}, (response) => {
            setExpensesAccounts(response.data.expenses_accounts);
            setLoading(false);
            setTotalRowCount(response.data.meta.totalRowCount);
        },
            (error) => {
                if (error.code === "ERR_NETWORK")
                    fetchExpensesAccounts(selectedAssociate);
            }
            , false, source.token);
    }

    useEffect(() => {
        fetchExpensesAccounts(selectedAssociate);
    }, [selectedAssociate])

    useEffect(() => {
        return () => {
            source.cancel('expenses_accounts list unmounted');
        }
    }, [])

    const createXpensesAccount = () => {
        setLoading(true);
        const payload = {description: newAccountDescription}
        if (selectedAssociate)
            payload.id_user = selectedAssociate.value
            
        fetch(  `/expenses_account/`, "POST", payload,
            response => {
                const account_id = response?.data?.expenses_account_id
                if (account_id)
                    openExpensesAccount(account_id);
            },
            error => {
                setLoading(false);
                const detail = readApiErrorCode(error);
                if (error?.response?.status !== 500 && detail) {
                    setSavingError(`${data.t.read("internal_saving_error")} : ${data.t.read(detail) ?? detail}`);
                } else {
                    setSavingError(data.t.read("internal_saving_error"));
                }
            }
            ,
            null, false, source.token)
    }

    const handleOpenNewAccount = () => {
        if (!data.isMobile) {
            setNewAccountDescription("");
            setOpenCreateAccountModal(true);
        } else {
            createXpensesAccount()
        }
    }
    const openExpensesAccount = (id) => {
        history(`/expenses_account/${id}`);
    }

    return !loading ? <div className="card p-1 mt-2 rounded-lg">
        
        <div className="card-body">
            <AsyncSelect
                    name="user"
                    loadOptions={loadUsersAndAssociates}
                    onChange={(choice) => {setSelectedAssociate(choice)}}
                    cacheOptions
                    defaultOptions
                    value={selectedAssociate ?? ""}
                    placeholder={data.t.read("user")}
                    styles={Utils.styleSelect}
                    classNamePrefix="select"
                    className={data.isMobile ? 'col-12 mb-2' : 'col-3'}
                />
            <div className="card-title d-flex justify-content-center">
                <h2>{data.t.read("expenses_account_list")}</h2>
            </div>
            { data.isMobile ?
            <>
                <ListHeader
                    checkboxDisabled={!expensesAccounts || !expensesAccounts.length}
                    isChecked={isAllXpensesSelected()}
                    onCheckboxChange={toggleAllXpensesSelected}
                    disableDeleteButton={saving || xpensesDeleteSelection.length === 0}
                    onDelete={() => setXpensesDeleteConfirm(true)}
                    onAdd={createXpensesAccount}
                    saving={saving}
                    data={data}
                />
                {expensesAccounts.map(inv =>
                    <ListItemDisplay key={`${inv._id.$oid}-list`} isSelected={isXpenseSelected(inv)} onSelectedChange={() => onExpenseAccountSelectedChange(inv)}>
                        <div onClick={() => openExpensesAccount(inv._id.$oid)} className="flex-1 pointer d-flex align-items-center">
                            <div className="ml-3 text-truncate flex-1">{data.t.read(`expense_account_status.${inv.status.toLowerCase()}`)}</div>
                            <div className="text-primary font-weight-bold ml-2">{inv.BigTotalPayed && `$${inv.BigTotalPayed.toFixed(2)}`}</div>
                            <div className="text-right text-muted flex-shrink-0" style={{width: '96px'}}>{Intl.DateTimeFormat(`${data.t.lang}-US`,{year: 'numeric',  month: '2-digit', day: '2-digit'}).format(new Date(inv.created_at.$date))}</div>
                        </div>
                    </ListItemDisplay>
                )}
            </>
            : <>
            <div className="d-flex justify-content-end m-1">
                <button type="button" className="mr-1 text-center pointer btn btn-sm btn-secondary btn-primary-shadow pb-2 pt-2" disabled={saving || xpensesDeleteSelection.length === 0} onClick={() => setXpensesDeleteConfirm(true)}>
                    {data.t.read("delete")}
                    {saving && <FontAwesomeIcon className="ml-2 text-secondary infinite-rotate faded" icon={faSync} />}
                </button>
                <button onClick={() => handleOpenNewAccount()} type="button"
                        className="btn btn-primary btn-primary-shadow">
                    {data.t.read("add_new")}
                </button>
            </div>
            <div className="table m-0 p-0">
                <table className="table table-hover m-0 p-0 table-borderless ">
                    <thead>
                        <tr>
                            <th><Checkbox disabled={!expensesAccounts || !expensesAccounts.length} isChecked={isAllXpensesSelected()} onChange={toggleAllXpensesSelected} /></th>
                            <th><div></div></th>
                            {allColums.map((availableColumn) => (
                                <th key={`header-${availableColumn.displayName}}`}>{data.t.read(`invoice.${availableColumn.displayName}`)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {expensesAccounts.map(inv => <tr key={`${inv._id.$oid}-list`}>
                            <td><Checkbox isChecked={isXpenseSelected(inv)} onChange={() => onExpenseAccountSelectedChange(inv)} /></td>
                            <td onClick={() => openExpensesAccount(inv._id.$oid)}>
                                {inv.status === "Pending" && <FontAwesomeIcon icon={faPencilAlt} />}
                                {["Submitted", "Need_Approval"].includes(inv.status) && <FontAwesomeIcon icon={faEllipsisH} style={{ color: 'blue' }} />}
                                {inv.status === "Validated" && <FontAwesomeIcon icon={faCheck} className='text-primary' />}
                                {inv.status === "Approved" && <FontAwesomeIcon icon={faCheckCircle} className='text-primary' />}
                                {inv.status === "Denied" && <FontAwesomeIcon icon={faCheckCircle} className='text-danger' />}
                            </td>
                            {
                                allColums.map(availableColumn => <td onClick={() => openExpensesAccount(inv._id.$oid)} key={`${inv._id.$oid}-${availableColumn.displayName}-value`}>{availableColumn.evaluate(inv)}</td>)}
                        </tr>
                        )}
                    </tbody>
                </table>
            </div></>}
        </div>
            {
                openCreateAccountModal &&
                <Modal title={data.t.read("new_expenses_account")} width={600} height={400} centered cancelAction={() => {
                    setNewAccountDescription("");
                    setOpenCreateAccountModal(false);
                }} okAction={() => {
                    setNewAccountDescription("");
                    createXpensesAccount();
                }} okText={data.t.read("add")} cancelText={data.t.read("cancel")}>
                    <form onSubmit={e => e.preventDefault()}>
                        <textarea className={"form-control form-control-sm"} value={newAccountDescription}
                                  onChange={e => setNewAccountDescription(e.target.value)}
                                  placeholder={data.t.read("description")}
                                  style={{minHeight: "150px", fontSize: "1.15rem"}}/>
                    </form>

                </Modal>
            }
        {
            xpensesDeleteConfirm &&
            <Modal title={data.t.read("confirm")} cancelAction={() => setXpensesDeleteConfirm(false)} okAction={() => deleteXpenses()} okText={data.t.read("delete")} cancelText={data.t.read("cancel")}>
                {data.t.read("delete")} ?
            </Modal>
        }
        {
            savingError != null &&
            <Modal title={data.t.read("error")} okAction={() => setSavingError(null)} okText={"ok"}>
                <div className="text-danger">
                    {savingError}
                </div>
            </Modal>
        }
    </div>
        :
        <div className="d-flex loading-container">
            <FontAwesomeIcon className="infinite-rotate" icon={faSpinner} />
        </div>
}

export default inject('data')(observer(ExpensesAccount));
